import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mic } from "lucide-react";
import { useApi, useMe } from "@/lib/api";
import { StatCard, PageTitle } from "@/components/Bits";
import SessionTable from "@/components/SessionTable";

export default function Dashboard() {
  const api = useApi();
  const { me } = useMe();
  const [sessions, setSessions] = useState([]);
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api("get", "/sessions").then(setSessions);
    api("get", "/me/stats").then(setStats);
  }, [api]);

  return (
    <div data-testid="dashboard-page" className="fade-up">
      <PageTitle kicker={`Welcome, ${me?.name || "traveller"}`} title="Your assessment history">
        <Link to="/interview/new" data-testid="dashboard-new-assessment-btn" className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-500 text-white px-6 py-3 transition-colors hover:-translate-y-0.5 transition-transform">
          <Mic className="w-4 h-4" /> Start new assessment
        </Link>
      </PageTitle>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
        <StatCard label="Assessments taken" value={stats?.total ?? "-"} testid="stat-total" />
        <StatCard label="Completed" value={stats?.completed ?? "-"} accent="text-blue-400" testid="stat-completed" />
        <StatCard label="In progress" value={stats?.in_progress ?? "-"} testid="stat-in-progress" />
        <StatCard label="Practice minutes" value={stats?.total_minutes ?? "-"} testid="stat-minutes" />
      </div>
      <p className="font-mono text-xs text-slate-500 mb-10" data-testid="assessment-private-note">Assessment results are reviewed by the super admin only.</p>


      <SessionTable sessions={sessions} />
    </div>
  );
}
